import script from "./OrderHistoryTile.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderHistoryTile.vue?vue&type=script&setup=true&lang=js"

import "./OrderHistoryTile.vue?vue&type=style&index=0&id=f31d8eda&lang=scss"

const __exports__ = script;

export default __exports__